// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div_title[data-v-0bb40f21]{text-align:center;width:100%;max-height:5%;height:30px;font-size:16px;font-weight:700;line-height:30px}\n", ""]);
// Exports
module.exports = exports;
